var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "has-logo": true } },
    [
      _c("logo", { attrs: { collapse: _vm.isCollapse } }),
      _c(
        "div",
        { staticClass: "menu-con" },
        [
          _c(
            "el-scrollbar",
            { attrs: { vertical: false, "wrap-class": "scrollbar-wrapper" } },
            [
              _c(
                "el-menu",
                {
                  attrs: {
                    collapse: _vm.isCollapse,
                    "collapse-transition": false,
                    "default-active": _vm.activeMenu,
                    "unique-opened": false,
                    mode: "vertical",
                  },
                },
                _vm._l(_vm.menus, function (menu) {
                  return _c("sidebar-item", {
                    key: menu.code,
                    attrs: { "base-path": menu.name, item: menu },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }